import { CourseDef } from '../../../../types';
import L2078932 from './2078932';
import L3893602 from './3893602';
import L2084276 from './2084276';
// import L5234412 from './5234412';
import L5472583 from './5472583';
import L2084095 from './2084095';
import L3893603 from './3893603';
import L3893604 from './3893604';
import L2084096 from './2084096';
import L2084274 from './2084274';
import L2084275 from './2084275';
import L5234414 from './5234414';
import L5234416 from './5234416';

export const boasVindas: CourseDef = {
  courseTitle: 'BOAS-VINDAS',
  lessons: [
    L2078932,
    L3893602,
    L2084276,
    // L5234412,
    L5472583,
    L2084095,
    L3893603,
    L3893604,
    L2084096,
    L2084274,
    L2084275,
    L5234414,
    L5234416,
  ],
};

